<template>
  <div class="my-password">
    <div class="password-title">
      パスワード変更
    </div>
    <div class="app-my-content">
      <el-form ref="resetPasswordForm" :model="form" class="app-form" :rules="rules">
        <el-form-item label="現在のパスワード" prop="oldPassword">
          <el-input type="password" v-model="form.oldPassword" autocomplete="off"
            placeholder="半角英数字大文字小文字含む8桁"
          ></el-input>
        </el-form-item>
        <el-form-item label="新しいパスワード" prop="newPassword">
          <el-input type="password" v-model="form.newPassword" autocomplete="off"
            placeholder="半角英数字大文字小文字含む8桁" maxlength="8"
          ></el-input>
        </el-form-item>
        <el-form-item label="新しいパスワード(再入力)" prop="newPasswordConfirm">
          <el-input type="password" v-model="form.newPasswordConfirm" autocomplete="off"
            placeholder="半角英数字大文字小文字含む8桁" maxlength="8"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="studypack-button-primary" type="primary" @click="onSubmit">変更</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import tools from '@/utils/tools';
import request from '@/utils/request';
import { Notification } from 'element-ui';
// const { checkPassword } = tools;

export default {
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        newPasswordConfirm: '',
      },
      rules: {
        oldPassword: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{8}$/, message: '半角英数字大文字小文字含む8桁で入力してください。', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{8}$/, message: '半角英数字大文字小文字含む8桁で入力してください。', trigger: 'blur' }
        ],
        newPasswordConfirm: [
          { required: true, message: '必須です。', trigger: 'blur' },
          // { validator: this.newPasswordConfirm, trigger: 'blur' },
          // { validator: checkPassword, trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.newPassword) {
                callback(new Error('新しいパスワードと一致しません。'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },

        ],
      },
    };
  },
  methods: {
    // newPasswordConfirm(rule, value, callback) {
    //   if (value === '') {
    //     callback(new Error('パスワードをもう一度入力してください。'));
    //   } else if (value !== this.form.newPassword) {
    //     callback(new Error('二回の入力パスワードが一致しません!'));
    //   } else {
    //     callback();
    //   }
    // },
    onSubmit() {
      this.$refs.resetPasswordForm.validate((valid) => {
        if (valid) {
          request('updatePassword', {
            password: this.form.oldPassword,
            newPassword: this.form.newPassword,
          }).then(() => {
            Notification({
              title: '成功',
              message: 'パスワードの変更が成功しました。',
              // duration: 0,
              offset: 75,
              type: 'success',
            });
            this.$router.push({
              path: '/login',
              query: { manshonId: sessionStorage.getItem('sessionManshonId') },
            }).catch(() => {});
          });
          return true;
        }
        console.log('error submit!!');
        return false;
      });
    },
  },
};
</script>

<style lang="less">
.my-password {
  margin: 10px auto;
  .password-title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 24px;
  }
}
</style>
